import './style.css'
import * as  THREE from 'three'
import { Color, LineBasicMaterial, MeshBasicMaterial, Vector3 } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls.js'
import { VRButton } from 'three/examples/jsm/webxr/VRButton.js'

import { GUI } from 'three/examples/jsm/libs/dat.gui.module.js'
import { InteractiveGroup } from 'three/examples/jsm/interactive/InteractiveGroup.js'
import { HTMLMesh } from 'three/examples/jsm/interactive/HTMLMesh.js'

import CAVertexShader from './shaders/CA/vertex.glsl'
import CAFragmentShader from './shaders/CA/fragment.glsl'

import firefliesVertexShader from './shaders/fireflies/vertex.glsl'
import firefliesFragmentShader from './shaders/fireflies/fragment.glsl'

import portalVertexShader from './shaders/portal/vertex.glsl'
import portalFragmentShader from './shaders/portal/fragment.glsl'

import splashVertexShader from './shaders/splash/vertex.glsl'
import splashFragmentShader from './shaders/splash/fragment.glsl'


import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'



uiAction()

const clock = new THREE.Clock()

const SPECTOR = require('spectorjs')
const spector = new SPECTOR.Spector()

//spector.displayUI()


const gui = new GUI({ width: 300, closed: true, autoPlace:false })



// canvas
const canvas = document.querySelector('canvas.webgl')

const debugUI =
{
    backgroundColor: 0xc0b3b3 //0xefd1b5 //0xd7d7d7
}



// scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(debugUI.backgroundColor)
//scene.fog = new THREE.FogExp2(0xefd1b5, 0.0025)

gui.addColor(debugUI, 'backgroundColor').onChange(() => { scene.background = new THREE.Color(debugUI.backgroundColor) })

const sizes =
{
    width: window.innerWidth,
    height: window.innerHeight
}

// camera
const camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.01, 1000)
camera.position.set(4, 0.5, 0.6)//(0, 1.6, 4)
camera.rotation.set(3.11, 1.05, -3.11)

scene.add(camera)



//control
const orbitControls = new OrbitControls(camera, canvas)
orbitControls.target = new THREE.Vector3(-0.079, 1.615, 1.672)
orbitControls.enableDamping = true
orbitControls.maxDistance = 5
orbitControls.maxPolarAngle = Math.PI/1.7
orbitControls.minPolarAngle = Math.PI/2.3



const boxParameters =
{
    width: 1,
    height: 1,
    depth: 1

}
// object
const boxGeometry = new THREE.BoxGeometry(...Object.values(boxParameters))
const boxDashedLine = new THREE.Line(boxGeometry, new THREE.LineDashedMaterial({ color: 0xffaa00, dashSize: 0.01, gapSize: 0.02}))
//scene.add(boxDashedLine)
boxDashedLine.position.set(0, boxParameters.height / 2 + 0.02, 0)


// set up ca variables
const xCellWidth = 300
const zCellWidth = 300

let state = []
let nextState = []
let caPosArray = []
let caPosAttribute = []


let count = 0
let maxLevel =70




// run CA 
buildCA()

// draw points
const pointGeometry = new THREE.BufferGeometry()
const pointCount = caPosArray.length
const positionArray = new Float32Array(pointCount * 3)


//convert caPosAttribute to Float32
for (let i = 0; i < caPosAttribute.length; i++)
{
    const scale = 0.35//0.06
    positionArray[i] = caPosAttribute[i] * scale
}
pointGeometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3))

const caRandomAttribute = new Float32Array(caPosAttribute.length)

for (let i = 0; i < caPosAttribute.length; i++)
{
    caRandomAttribute[i] = Math.random()
}

pointGeometry.setAttribute('aRandom', new THREE.BufferAttribute(caRandomAttribute,1))

debugUI.caColor = '#121342'
const pointMaterial = new THREE.ShaderMaterial(
    {
        /*vertexColors: true,*/
       
        vertexShader: CAVertexShader,
        fragmentShader: CAFragmentShader,
        transparent: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        side: THREE.DoubleSide,
        wireframe: true,
        //sizeAttenuation:true,
       
        uniforms:
        {
            uTime: { value: 0 },
            uColor: { value: new THREE.Color(debugUI.caColor) },
            uPixelRatio: { value: Math.min(devicePixelRatio,2) }
        }
    })

const points = new THREE.Points(pointGeometry, pointMaterial)
scene.add(points)
points.y = -2
gui.add(points.position, 'y').min(-10).max(10)
gui.add(points.rotation, 'x').min(-Math.PI * 2).max(Math.PI * 2).step(Math.PI/2)

gui.addColor(debugUI, 'caColor').onChange(() => {
    pointMaterial.uniforms.uColor.value = new THREE.Color(debugUI.caColor)
})

debugUI.portalColorStart = '#464c5c' //'#414141'
debugUI.portalColorEnd = 0xd7d7d7 //0x505050

const groundMaterial = new THREE.ShaderMaterial(
    {
        vertexShader: portalVertexShader,
        fragmentShader: portalFragmentShader,
        side: THREE.DoubleSide,
        uniforms:
        {
            uTime: { value: 0 },
            uColorStart: { value: new THREE.Color(debugUI.portalColorStart) },
            uColorEnd: { value: new THREE.Color(debugUI.portalColorEnd) }//0x505050
        }
    })

gui.addColor(debugUI, 'portalColorStart').onChange(() => { groundMaterial.uniforms.uColorStart.value = new THREE.Color(debugUI.portalColorStart) })
gui.addColor(debugUI, 'portalColorEnd').onChange(() => { groundMaterial.uniforms.uColorEnd.value = new THREE.Color(debugUI.portalColorEnd) })

const groundPlane = new THREE.Mesh(new THREE.PlaneGeometry(50, 50, 64, 64), groundMaterial)
scene.add(groundPlane)
groundPlane.rotation.x = -Math.PI / 2
groundPlane.position.y=0.02



const sphereMaterial = new THREE.ShaderMaterial(
    {
        vertexShader: splashVertexShader,
        fragmentShader: splashFragmentShader,
        side: THREE.DoubleSide,
        //wireframe: true,
        uniforms:
        {
            uTime: { value: 0 },
            uWavesFreq: { value: new THREE.Vector2(3, 5) },
            uWavesAmp: { value: 0.2 },
            uWavesSpeed: { value: 0.05 },
            //uSurfaceColor: { value: new THREE.Color(debugObj.surfaceColor) },
            //uDepthColor: { value: new THREE.Color(debugObj.depthColor) },

        }
    })


const sphere = new THREE.Mesh(new THREE.SphereGeometry(12, 64, 32), groundMaterial)

sphere.rotation.z = Math.PI / 2
sphere.scale.x = 0.6
scene.add(sphere)

const firefliesGeometry = new THREE.BufferGeometry()

const firefliesCount = 300
const firefliesPositionArray = new Float32Array(firefliesCount * 3)

for (let i = 0; i < firefliesCount; i++)
{
    firefliesPositionArray[i * 3] = (Math.random()-0.5) * 11
    firefliesPositionArray[i * 3 + 1] = (Math.random()) * 5
    firefliesPositionArray[i * 3 + 2] = (Math.random()-0.5) * 11
}

firefliesGeometry.setAttribute('position', new THREE.BufferAttribute(firefliesPositionArray, 3))

const firefliesRandomAttribute = new Float32Array(firefliesCount)

for (let i = 0; i < firefliesCount; i++)
{
    firefliesRandomAttribute[i] = Math.random()
}

firefliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(firefliesRandomAttribute, 1))

const firefliesMaterial = new THREE.ShaderMaterial(
    {
        vertexShader: firefliesVertexShader,
        fragmentShader: firefliesFragmentShader,
        transparent: true,
        vertexColors: true,
        blending: THREE.AdditiveBlending,
        depthWrite:false,
        uniforms:
        {
            uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
            uTime: {value:0}
        }
    })
const fireflies = new THREE.Points(firefliesGeometry, firefliesMaterial)

scene.add(fireflies)

// 3dfont
const fontLoader = new THREE.FontLoader()

const huey = new THREE.Group()
//scene.add(huey)

fontLoader.load(
    './fonts/Nunito ExtraBold_Regular.json',
    (font) =>
    {

        const textParameter =
        {
            font: font,
            size: 0.5,
            height: 0.2,
            depth:0.02,
            bevelEnabled: true,
            bevelThickness: 0.03,
            bevelSize: 0.02,
            bevelOffset: 0,
            bevelSegments:5

        }
        const hGeometry = new THREE.TextBufferGeometry('h', textParameter)  
        const uGeometry = new THREE.TextBufferGeometry('u', textParameter) 
        const eGeometry = new THREE.TextBufferGeometry('e', textParameter) 
        const yGeometry = new THREE.TextBufferGeometry('y', textParameter) 

        //hGeometry.center()
        //uGeometry.center()
        //eGeometry.center()
        //yGeometry.center()

        const textMaterial = new THREE.MeshNormalMaterial()

        const hLetter = new THREE.Mesh(hGeometry, textMaterial)
        const uLetter = new THREE.Mesh(uGeometry, textMaterial)
        const eLetter = new THREE.Mesh(eGeometry, textMaterial)
        const yLetter = new THREE.Mesh(yGeometry, textMaterial)

        scene.add(hLetter, uLetter, eLetter, yLetter)
       

        hLetter.position.set(-1, 0.25, 0)
        uLetter.position.set(hLetter.position.x + 0.5, hLetter.position.y, hLetter.position.z)
        eLetter.position.set(hLetter.position.x + 1.0, hLetter.position.y, hLetter.position.z)
        yLetter.position.set(hLetter.position.x + 1.5, hLetter.position.y, hLetter.position.z)

        huey.add(hLetter, uLetter, eLetter, yLetter)

    })



// grid

for (let i = 0; i < 1; i++)
{
    const grid = new THREE.GridHelper(10, 10, '#f2f2e2', '#f2f2e2')
    //scene.add(grid)
    grid.position.y=i
}




// light
const hemisphereLight = new THREE.HemisphereLight(0xd4d4d4, 0xb3b3b3,0.5)
//scene.add(hemisphereLight)


// renderer
const renderer = new THREE.WebGLRenderer(
    {
        canvas: canvas,
        antialias: true
    })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

document.body.appendChild(VRButton.createButton(renderer))
renderer.xr.enabled = true

//renderer.outputEncoding = THREE.sRGBEncoding
//renderer.physicallyCorrectLights = true
//renderer.toneMapping = THREE.ACESFilmicToneMapping

const effectComposer = new EffectComposer(renderer)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
effectComposer.setSize(sizes.width, sizes.height)

const renderPass = new RenderPass(scene, camera)
effectComposer.addPass(renderPass)

const bloomPass = new UnrealBloomPass()
effectComposer.addPass(bloomPass)




window.addEventListener('resize', () =>
{
    //sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    //camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    //renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    //fpControls.handleResize()

    // effectComposer
    effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    effectComposer.setSize(sizes.width, sizes.height)

})

//-------------------------------------------------------------------------------------------------------//


gui.add(boxParameters, 'width').min(0.1).max(10).step(0.2).onChange(onBoxParamChange)
gui.add(boxParameters, 'height').min(0.1).max(10).step(0.2).onChange(onBoxParamChange)
gui.add(boxParameters, 'depth').min(0.1).max(10).step(0.2).onChange(onBoxParamChange)

function onBoxParamChange()
{
    boxDashedLine.geometry.dispose()
    boxDashedLine.geometry = new THREE.BoxGeometry(...Object.values(boxParameters))
    boxDashedLine.position.y = boxParameters.height/2
}

//const interactiveGroup = new InteractiveGroup(renderer, camera)
//scene.add(interactiveGroup)

//const guiMesh = new HTMLMesh(gui.domElement)
//guiMesh.position.set(-0.75, 1.5, -0.5)
//guiMesh.rotation.y = Math.PI / 2
//guiMesh.scale.setScalar(2)
//interactiveGroup.add(guiMesh)

//-------------------------------------------------------------------------------------------------------//



const animate = () =>
{

    const elapsedTime = clock.getElapsedTime()

    orbitControls.update()

    renderer.render(scene, camera)

    window.requestAnimationFrame(animate)
}

//animate()

const render = () =>
{
    const elapsedTime = clock.getElapsedTime()

    effectComposer.render()

     //clamp orbit controls to restrict view scope
    if (orbitControls.target.y > 1.6)
    {
        orbitControls.target.setY(1.6)
    }

    if (orbitControls.target.y < 1.55)
    {
        orbitControls.target.setY(1.55)
    }

    if (orbitControls.target.z > 1.9) {
        orbitControls.target.setZ(1.9)
    }

    if (orbitControls.target.z < -1.9) {
        orbitControls.target.setZ(-1.9)
    }

    if (orbitControls.target.x > 1.9) {
        orbitControls.target.setX(1.9)
    }

    if (orbitControls.target.x < -1.9) {
        orbitControls.target.setX(-1.9)
    }

    firefliesMaterial.uniforms.uTime.value = elapsedTime
    pointMaterial.uniforms.uTime.value = elapsedTime
    groundMaterial.uniforms.uTime.value = elapsedTime

    //points.rotation.y = elapsedTime * 0.05
    sphere.rotation.y = -elapsedTime * 0.02
    huey.position.y = Math.sin(elapsedTime) + 2

  
    if (elapsedTime % 5 < 0.5)
    {
        huey.position.x = (Math.random()-0.5) * 5
        huey.position.z = (Math.random()-0.5) * 5
    }

    //huey.position.x = Math.sin(elapsedTime * 0.2) * 2
    //huey.position.z = Math.cos(elapsedTime * 0.2)

    //huey.rotation.y = -(Math.PI / 2)  + ( Math.PI * elapsedTime * 0.1)
    
    huey.lookAt(camera.position)

    orbitControls.update()

    renderer.render(scene, camera)
}

const animateVR = () =>
{       

    renderer.setAnimationLoop(render)
}

animateVR()

//-------------------------------------------------------------------------------------------------------//


function buildCA()
{
    for (let i = 0; i < xCellWidth; i++)
    {
        state[i] = []
        nextState[i] = []
        for (let j = 0; j < zCellWidth; j++)
        {
            state[i][j] = false
        }
    }
    // set glider true states here
    //state[xCellWidth / 2][xCellWidth / 2] = true
    //state[xCellWidth / 2 - 2][xCellWidth / 2] = true
    //state[xCellWidth / 2 + 1][xCellWidth / 2] = true
    //state[xCellWidth / 2 + 1][xCellWidth / 2 - 1] = true
    //state[xCellWidth / 2][xCellWidth / 2 - 2] = true

    //state[5][5] = true
    //state[5 - 2][5] = true
    //state[5 + 1][5] = true
    //state[5 + 1][5 - 1] = true
    //state[5][5 - 2] = true

    const midXY = xCellWidth / 2 ;

    glider(state, midXY -10, midXY - 25) // top
    glider(state, midXY +10, midXY - 25) //top right

    glider(state, midXY - 10, midXY + 25) // bottom
    glider(state, midXY + 10, midXY + 25) //bottom right    
   
    //left
    glider_b(state, midXY - 20, midXY )
    glider_b(state, midXY - 20, midXY - 5 )

    glider_b(state, midXY-15, midXY )
    glider_b(state, midXY - 15, midXY - 5)


    ////bottom
    //glider_b(state, midXY + 20, midXY)
    //glider_b(state, midXY + 20, midXY - 5)

    //glider_b(state, midXY + 15, midXY)
    //glider_b(state, midXY + 15, midXY - 5)



    glider_b(state, midXY + 20, midXY - 20)
    glider_b(state, midXY + 20, midXY - 5 - 20)

    glider_b(state, midXY + 15, midXY -20)
    glider_b(state, midXY + 15, midXY - 5 - 20)

  


    while (count < maxLevel)
    {
        for (let i = 0; i < xCellWidth; i++)
        {
            for (let j = 0; j < zCellWidth; j++)
            {

                // 1 - register true states position
                if (state[i][j] === true)
                {

                    //bring it to center by adding the width/2
                    const newi = i + -xCellWidth/2
                    const newj = j + -zCellWidth/2

                    const pos =
                    {
                        x: newi*0.8,
                        y: count * 0.2,
                        z: newj * 0.8
                    }
                    caPosArray.push(pos)

                    caPosAttribute.push(pos.x)
                    caPosAttribute.push(pos.y)
                    caPosAttribute.push(pos.z)
                }

                let aliveCells = 0

                // 2 - check neighbour
                for (let m = -1; m <= 1; m++)
                {
                    for (let k = -1; k <= 1; k++)
                    {
                        if (!(m === 0 & k === 0))
                        {
                            if (state[(m + i + xCellWidth) % xCellWidth][(k + j + zCellWidth) % zCellWidth] === true)
                            {
                                aliveCells++
                            }
                        }
                    }
                }

                // 3 - rules
                if (aliveCells < 2 || aliveCells > 3) {
                    nextState[i][j] = false
                }
                else if (aliveCells === 3 )//|| aliveCells === 1)
                {
                   nextState[i][j]=true

                }
                else
                {
                    nextState[i][j] = state[i][j]
                }

                

            }
        }
        

        for (let i = 0; i < xCellWidth; i++)
        {
            for (let j = 0; j < zCellWidth; j++)
            {
                state[i][j] = nextState[i][j]

            }
        }

        count++

    }  

}

//buildCA()
//console.log('states = ' + state)
//console.log(caPosArray)
//console.log(caPosAttribute)


function glider(state, x, y)
{
    
    state[x - 2][y + 1] = true
    state[x - 2][y] = true
    state[x - 2][y - 1] = true
    state[x - 1][y + 2] = true
    state[x - 1][y - 2] = true
    state[x][y + 3] = true
    state[x][y - 3] = true
    state[x + 1][y + 2] = true
    state[x + 1][y - 2] = true
    state[x + 2][y + 1] = true
    state[x + 2][y] = true
    state[x + 2][y - 1] = true
    state[x + 3][y + 1] = true
    state[x + 3][y] = true
    state[x + 3][y - 1] = true

}

function glider_b(state, x, y)
{
    
    state[x-2][y] = true
    state[x-2][y+1] = true
    state[x-1][y-1] = true
    state[x-1][y+2] = true
    state[x][y-1] = true
    state[x][y+2] = true
    state[x+1][y-1] = true
    state[x+1][y+2] = true
    state[x+2][y] = true
    state[x+2][y+1] = true
}

function uiAction()
{
    $("#infoPopup").toggle() 

    $("#info").click(function ()
    {
         $("#infoPopup").toggle(500)   
    })

    //$("#info").bind("tap",function () {
    //    $("#infoPopup").toggle(500)
    //})


}